import React, { useEffect, useState } from 'react';

import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
// import { useTranslation } from 'react-i18next';

import useStyle from './style';

import { ReportViewType } from 'types';

interface Props {
  selectedReportViewType: string;
  handleSelected: (string) => void;
}

export default function ReportView({
  selectedReportViewType: parentSelectedReportViewType,
  handleSelected,
}: Props): JSX.Element {
  //   const { t } = useTranslation();
  const classes = useStyle();
  const [selectedReportViewType, setSelectedReportViewType] = useState(null);

  useEffect(() => {
    setSelectedReportViewType(parentSelectedReportViewType);
  }, [parentSelectedReportViewType]);

  const onViewChange = (value): void => {
    setSelectedReportViewType(value as ReportViewType);
    handleSelected && handleSelected(value as ReportViewType);
  };

  return (
    <div className={classes.reportViewType}>
      View Type:
      <RadioGroup
        aria-label="viewType"
        name="viewType"
        onChange={(event): void => onViewChange(event.target.value)}
        value={selectedReportViewType}
        row={true}
        className={classes.radioInputs}
      >
        <FormControlLabel
          control={<Radio size="small" color="primary" data-testid="report-view-list" />}
          label="List"
          value={ReportViewType.LIST}
        />
        <FormControlLabel
          control={<Radio size="small" color="primary" data-testid="report-view-report" />}
          label="Report"
          value={ReportViewType.REPORT}
        />
      </RadioGroup>
    </div>
  );
}
